import { apiFetch } from "@/shared/api/http";

export interface GraduationHistoryItem {
  id:string;
  tipo:string;
  faixa:string;
  grau:number;
  data:string;
  professor:string;
  observacao?:string|null;
}
export interface GraduationEligibility { proximaFaixa?:string|null; mesesNaFaixa:number; tempoMinimoAtingido:boolean; idadeAtual:number; idadeMinimaAtingida:boolean; frequenciaPercentual:number; frequenciaMinimaAtingida:boolean; quatroGrausAtingidos:boolean; elegivelParaAvaliacaoFaixa:boolean; observacao?:string|null; }
export interface GraduationSummary {
  alunoId:string;
  aluno:string;
  faixaAtual?:string|null;
  grausAtuais:number;
  ultimaProgressao?:string|null;
  historico:GraduationHistoryItem[];
  elegibilidade?:GraduationEligibility|null;
}

export function getStudentGraduation(){
  return apiFetch<GraduationSummary>("/api/app/aluno/graduacao");
}
export function getResponsibleGraduation(studentId:string){
  return apiFetch<GraduationSummary>(`/api/app/responsavel/alunos/${encodeURIComponent(studentId)}/graduacao`);
}
export function getProfessorGraduation(turmaId:string, studentId:string){
  return apiFetch<GraduationSummary>(`/api/app/professor/alunos/${encodeURIComponent(studentId)}/graduacao?turmaId=${encodeURIComponent(turmaId)}`);
}
export function grantProfessorDegree(turmaId:string, studentId:string, data:string, observacao?:string){
  return apiFetch<string>(`/api/app/professor/alunos/${encodeURIComponent(studentId)}/graduacao/graus`,{method:"POST",body:JSON.stringify({turmaId,data,observacao:observacao?.trim()||null})});
}

export function removeLastProfessorDegree(turmaId:string, studentId:string, data:string, motivo:string){
  return apiFetch<string>(`/api/app/professor/alunos/${encodeURIComponent(studentId)}/graduacao/graus/correcao`,{method:"POST",body:JSON.stringify({turmaId,data,motivo:motivo.trim()})});
}
